export default "__VITE_ASSET__DF6IrMY5__"